import { ITRConstants } from '../Constants';

export function Itr(state = {}, action) {
    switch (action.type) {
        case ITRConstants.POST_ITR_DOCUMENTS_REQUEST:
            return {
                ...state,
                postloading: true
            };
        case ITRConstants.POST_ITR_DOCUMENTS_SUCCESS:
            return {
                ...state,
                postloading: false,
                postResult: action.itr
            };
        case ITRConstants.POST_ITR_DOCUMENTS_FAILURE:
            return {
                ...state,
                postloading: false,
                postError: action.error
            };
        default:
            return state
    }
}